import React, { PureComponent } from 'react'
import Spinner from 'react-bootstrap/Spinner'

import './Loading.scss';

export interface LoadingProps {
    visible?: boolean;
}

export class Loading extends PureComponent<LoadingProps> {
    render() {
        return (
            <>
                {
                    !this.props.visible ? '' :
                        <Spinner className='Loading' animation="border" role="status">
                            <span className="sr-only">Carregando...</span>
                        </Spinner>
                }

            </>
        )
    }
}